import { useContext, useEffect, useState } from "react"
import { useLocation } from "react-router-dom"
import { Button, Loader } from "../Styles"
import { toast } from "react-toastify"
import { listarDashboard } from "../../services/dashboard"
import { FaMoneyBill } from "react-icons/fa"
import { IndicadoresProjetoMensuracao, indicadoresTarefa } from "../../interfaces/indicadores"
import NenhumResultadoEncontrado from "../NenhumResultadoEncontrato"
import GraficoBarra from "../GraficoBarra"
import GraficoCard from "../GraficoCard"
import GraficoLinha from "../GraficoLinha"
import GraficoPizza from "../GraficoPizza"
import FiltroContainer from "../FiltroDashboard"
import GraficoColuna from "../GraficoColuna"
import "./index.css"
import ModalGraficoCard from "../ModalGraficoCard"
import { ModalEstadoContext } from "../../contexts/ModalEstado"

function Dashboard() {
  const { search } = useLocation()
  const paramsUrl = new URLSearchParams(search)
  const { modal, modalExibir } = useContext(ModalEstadoContext)

  const idProjeto = paramsUrl.get("idProjeto");

  const [processando, setProcessando] = useState(false);
  const [nenhumResultado, setNenhumResultado] = useState(false);

  const [dataInicio, setDataInicio] = useState<string>("");
  const [dataFinal, setDataFinal] = useState<string>(new Date().toISOString().slice(0, 7));
  const [indicadores, setIndicadores] = useState<IndicadoresProjetoMensuracao[]>([]);
  const [situacao, setSituacao] = useState(false);

  const [indicadorSelecionado, setIndicadorSelecionado] = useState<indicadoresTarefa | null>(null);

  const abrirModalCard = (indicador: indicadoresTarefa) => {
    setIndicadorSelecionado(indicador);
    return modalExibir("ModalGraficoCard");
  }

  const filtrar = async (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado.");
      if (dataFinal < dataInicio) return toast.warn("Data Final não pode ser menor que a data de Inicio.");
      setNenhumResultado(false)
      setProcessando(true);

      const dataInicioFormatada = new Date(dataInicio);
      const dataFinalFormatada = new Date(dataFinal);

      const dataInicioString = dataInicioFormatada.toISOString().slice(0, 7);
      const dataFinalString = dataFinalFormatada.toISOString().slice(0, 7);

      const resposta = await listarDashboard({
        idProjeto,
        dataInicial: dataInicioString,
        dataFinal: dataFinalString,
        situacao: situacao ? "" : "Ativo"
      });

      const indicadoresValidos = resposta.data.filter((item: any) => item.indicadore !== null);

      if (resposta.status === 200 && indicadoresValidos.length > 0) {
        setIndicadores(indicadoresValidos);
        return setNenhumResultado(false);
      }

      if (indicadoresValidos.length === 0) {
        setNenhumResultado(true);
        toast.info("Nenhum resultado encontrado.");
        setIndicadores([]);
        return;
      }
    } catch (error) {
      setNenhumResultado(true)
      toast.error('Erro ao buscar dados');
    } finally {
      setProcessando(false);
    }
  };

  const filtrarPorSituacao = async (situacao: boolean) => {
    try {
      if (!idProjeto) return toast.error("Projeto não encontrado.");

      setProcessando(true);
      setNenhumResultado(false);

      const resposta = await listarDashboard({
        idProjeto,
        dataInicial: dataInicio,
        dataFinal: dataFinal,
        situacao: situacao ? "" : "Ativo"
      });

      if (resposta.status === 200) {
        setIndicadores(resposta.data);
        setNenhumResultado(resposta.data.length === 0);
      }
    } catch (error) {
      toast.error("Erro ao listar graficos Inativos.");
      setNenhumResultado(true);
    } finally {
      setProcessando(false);
    }
  };

  useEffect(() => {
    async function carregarDados() {
      try {
        if (!idProjeto) return toast.error("Projeto não encontrado.")
        setNenhumResultado(false)
        setProcessando(true)
        const hoje = new Date();
        const dataInicioDate = new Date();
        dataInicioDate.setMonth(dataInicioDate.getMonth() - 11);

        const dataInicioFormatada = dataInicioDate.toISOString().slice(0, 7);
        const dataFinalFormatada = hoje.toISOString().slice(0, 7);

        setDataInicio(dataInicioFormatada);
        setDataFinal(hoje.toISOString().slice(0, 7));

        const resposta = await listarDashboard({
          idProjeto,
          dataInicial: dataInicioFormatada,
          dataFinal: dataFinalFormatada,
          situacao: "Ativo"
        });

        if (resposta.data.length === 0) {
          return setNenhumResultado(true)
        }
        if (resposta.status === 200) {
          setIndicadores(resposta.data);
          return setNenhumResultado(false);
        }
      } catch (error) {
        setNenhumResultado(true)
        toast.error("Erro ao Listar Dados de Faturamento.")
      } finally {
        setProcessando(false)
      }
    }

    carregarDados();
  }, [idProjeto]);

  return (
    <>
      {modal.nome === "ModalGraficoCard" && indicadorSelecionado && <ModalGraficoCard indicador={indicadorSelecionado} />}
      <FiltroContainer submit={filtrar}>
        <span>
          <label htmlFor="">Data Inicial</label>
          <input type="month" onChange={(e) => setDataInicio(e.target.value)} defaultValue={dataInicio} />
        </span>
        <span>
          <label htmlFor="">Data Final</label>
          <input type="month" onChange={(e) => setDataFinal(e.target.value)} min={dataInicio} defaultValue={dataFinal} />
        </span>

        <Button type='submit' isLoading={processando} cor='filtros'>
          {!processando && <>Pesquisar</>}
          {processando && <Loader isLoading={processando} />}
        </Button>

        <div className="container-toggle">
          <input
            className='toggle-situacao'
            id={`toggle-situacao`}
            type="checkbox"
            checked={situacao}
            onChange={(e) => {
              const novaSituacao = e.target.checked;
              setSituacao(novaSituacao);
              filtrarPorSituacao(novaSituacao);
            }
            }
          />
          <label
            className='label-toggle-situacao'
            htmlFor={`toggle-situacao`}
          ></label>
          <p>Vê Inativos</p>
        </div>
      </FiltroContainer>

      {nenhumResultado && <NenhumResultadoEncontrado />}
      <div className='dashboardContainer'>
        <div className='dashboardCardContainer'>
          {
            indicadores.map((indicador) => (
              indicador.indicadore?.tipoGrafico === "Card" &&
              (<GraficoCard indicador={indicador.indicadore} Icon={FaMoneyBill} onClick={() => abrirModalCard(indicador.indicadore)} />)
            ))
          }
        </div>
        <div className="dashboardGraficoContainer">
          {
            indicadores.map((indicador) => (
              indicador.indicadore?.tipoGrafico === "Colunas" &&
              (<GraficoColuna indicador={indicador.indicadore} />)
            )
            )
          }
          {
            indicadores.map((indicador) => (
              indicador.indicadore?.tipoGrafico === "Linhas" &&
              (<GraficoLinha indicador={indicador.indicadore} />)
            )
            )
          }
          {
            indicadores.map((indicador) => (
              indicador.indicadore?.tipoGrafico === "Pizza" &&
              (<GraficoPizza indicador={indicador.indicadore} />)
            )
            )
          }
          {
            indicadores.map((indicador) => (
              indicador.indicadore?.tipoGrafico === "Barras" &&
              (<GraficoBarra key={indicador.indicadore.id} indicador={indicador.indicadore} />)
            )
            )
          }
        </div>
      </div>
    </>
  )
}

export default Dashboard
